import { createAction, props } from '@ngrx/store';

//create User actions
export const CREATE_USER = '[User] Create User';
export const CREATE_USER_SUCCESS = '[User] Create User Success';
export const CREATE_USER_FAILURE = '[User] Create User Failures';

//Update Users Actions
export const UPDATE_USER = '[User] Update User';
export const UPDATE_USER_SUCCESS = '[User] Update User Success';
export const UPDATE_USER_FAILURE = '[User] Update User Failures';

//GET User By Id
export const GET_USER_BY_ID = '[User] Get User By ID';
export const GET_USER_BY_ID_SUCCESS = '[User] Get User By ID Success';
export const GET_USER_BY_ID_FAILURE = '[User] Get User By ID Failures';

//createuser by Create User
export const createUser = createAction(CREATE_USER, props<{ data: any }>());
export const createUserSuccess = createAction(
  CREATE_USER_SUCCESS,
  props<{ data: any }>()
);
export const createUserFailure = createAction(
  CREATE_USER_FAILURE,
  props<{ data: any }>()
);
//createactions by getBYID User
export const getUserById = createAction(GET_USER_BY_ID, props<{ id: any }>());
export const getUserByIdSuccess = createAction(
  GET_USER_BY_ID_SUCCESS,
  props<{ data: any }>()
);
export const getUserByIdFailure = createAction(
  GET_USER_BY_ID_FAILURE,
  props<{ id: any }>()
);

//createactions by Update Package
export const updateUser = createAction(UPDATE_USER, props<{ data: any }>());
export const updateUserSuccess = createAction(
  UPDATE_USER_SUCCESS,
  props<{ data: any }>()
);
export const updateUserFailure = createAction(
  UPDATE_USER_FAILURE,
  props<{ id: any }>()
);

export const clearProfileImage = createAction
('[User] Clear Profile Image');

